import { useEffect, useState, useCallback } from 'react';
import LogRocket from 'logrocket';
import { useAppSelector } from './redux';
import {
  LOG_ROCKET_COOKIE_NAME,
  LOG_ROCKET_COOKIE_VALUE,
  LOG_ROCKET_LAUNCH_ID,
  LogRocketKey,
} from '../constants/configuration';
import { userInfoApi } from '../services/apiServices/user/userInfo';
import { getCookie, setCookie } from '../utils';

export const useLogRocket = () => {
  const [isShowRocketLogMode, setIsShowRocketLogMode] = useState(false);
  const { isAuth } = useAppSelector((state) => state.authReducer);
  const { data: userInfo } = userInfoApi.useGetUserInfoQuery('', { skip: !isAuth });
  const [count, setCount] = useState(0);

  const handleLaunchLogRocket = useCallback(
    ({ target }) => {
      const num = count + 1;

      if (target.id !== LOG_ROCKET_LAUNCH_ID) {
        setCount(0);
        return;
      }
      if (num === 5 && !isShowRocketLogMode && LogRocketKey) {
        LogRocket.init(LogRocketKey);
        LogRocket.identify('WEB', {
          name: userInfo?.Name || '',
          email: userInfo?.EmailSettings?.Email || '',
          id: userInfo?.id || '',
        });
        setCount(0);
        setCookie(LOG_ROCKET_COOKIE_NAME, LOG_ROCKET_COOKIE_VALUE, 1800);
        setIsShowRocketLogMode(true);
        return;
      }
      setCount(num);
    },
    [isShowRocketLogMode, count, userInfo],
  );

  useEffect(() => {
    const isLogRocketInited = !!getCookie(LOG_ROCKET_COOKIE_NAME);
    if (isLogRocketInited && userInfo?.id && LogRocketKey) {
      LogRocket.init(LogRocketKey);
      LogRocket.identify('WEB', {
        name: userInfo?.Name || '',
        email: userInfo?.EmailSettings?.Email || '',
        id: userInfo?.id || '',
      });
      setIsShowRocketLogMode(true);
    }
  }, [userInfo]);

  useEffect(() => {
    document.addEventListener('click', handleLaunchLogRocket);
    return () => {
      document.removeEventListener('click', handleLaunchLogRocket);
    };
  }, [handleLaunchLogRocket]);

  return { isShowRocketLogMode };
};
